<template>
  <div>
    <el-button
      v-if="!isEditing"
      style="margin-bottom: 10px"
      type="primary"
      icon="el-icon-edit"
      @click="enterEdit()"
      >编辑</el-button
    >
    <el-button
      v-if="isEditing"
      style="margin-bottom: 10px"
      icon="el-icon-close"
      @click="cancelEdit()"
      >取消</el-button
    >
    <el-button
      v-if="isEditing"
      style="margin-bottom: 10px"
      type="primary"
      icon="el-icon-check"
      @click="save()"
      >保存</el-button
    >

    <el-tooltip style="margin-left: 15px" effect="dark" placement="top">
      <div slot="content">
        可玩日用于未成年人防沉迷规则——未成年人仅在登记的可玩日 20:00-21:00 可以游玩。<br />
        请录入所有可玩日期：包含周五/六/日以及法定节假日；调休补班日不录入。<br />
        每行一个可玩日，格式：<code>日期 [备注]</code>。<br />
        备注可省略；存在备注时，日期与备注之间允许用中文逗号、英文逗号或空白符分隔。<br />
        日期格式必须为 YYYY-MM-DD，例如 2026-10-01。<br />
        保存时会一次性覆盖整个集合。<br />
        示例：<br />
        2026-01-01 元旦<br />
        2026-10-01,国庆节<br />
        2026-10-02，国庆节<br />
        2026-10-03
      </div>
      <span style="font-size: 1.5rem"><i class="el-icon-question"></i></span>
    </el-tooltip>

    <div style="margin-top: 8px; color: #999; font-size: 12px">
      共 {{ lineCount }} 行（空行忽略）
    </div>

    <el-input
      v-model="text"
      type="textarea"
      :rows="25"
      :readonly="!isEditing"
      placeholder="每行一个可玩日"
      style="width: 700px; margin-top: 6px"
    />
  </div>
</template>

<script>
const axios = require("axios");

export default {
  data() {
    return {
      isEditing: false,
      text: "",
    };
  },

  computed: {
    lineCount() {
      if (!this.text) return 0;
      return this.text
        .split(/\r?\n/)
        .filter((line) => line.trim() !== "").length;
    },
  },

  async created() {
    await this.loadList();
  },

  methods: {
    async loadList() {
      try {
        const resData = (
          await axios.post(
            `${this.$util.getBackendApiBase()}/v1/admin/listPlayableDays`,
            {},
            { headers: { token: this.$bizutil.getLoginUserToken() } }
          )
        ).data;
        if (resData.code > 0) {
          this.$message({ message: resData.message, type: "error" });
          return;
        }
        const items = resData.data.playableDays || [];
        this.text = items
          .map((it) => `${it.date} ${it.remark || ""}`.trim())
          .join("\n");
      } catch (e) {}
    },

    enterEdit() {
      this.isEditing = true;
    },

    async cancelEdit() {
      this.isEditing = false;
      await this.loadList();
    },

    /**
     * 解析 textarea 内容，返回 { date, remark }[] 或抛出错误。
     * 每行一个可玩日。备注可省略；当存在备注时，日期与备注之间允许中英文逗号或空白符。
     */
    parseText() {
      const items = [];
      const seen = new Set();
      const lines = this.text.split(/\r?\n/);
      for (let i = 0; i < lines.length; i++) {
        const raw = lines[i].trim();
        if (!raw) continue;
        // 形式 1: 只有日期；形式 2: 日期 + 分隔符 + 备注
        const m = raw.match(/^(\S+)(?:[\s,，]+(.+))?$/);
        if (!m) {
          throw new Error(`第 ${i + 1} 行格式错误`);
        }
        const date = m[1];
        const remark = (m[2] || "").trim();
        if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) {
          throw new Error(
            `第 ${i + 1} 行日期格式错误（需 YYYY-MM-DD）：${date}`
          );
        }
        if (seen.has(date)) {
          throw new Error(`日期 ${date} 重复（第 ${i + 1} 行）`);
        }
        seen.add(date);
        items.push({ date, remark });
      }
      return items;
    },

    async save() {
      let items;
      try {
        items = this.parseText();
      } catch (e) {
        this.$message({ message: e.message, type: "error" });
        return;
      }

      try {
        const resData = (
          await axios.post(
            `${this.$util.getBackendApiBase()}/v1/admin/replacePlayableDays`,
            { playableDays: items },
            { headers: { token: this.$bizutil.getLoginUserToken() } }
          )
        ).data;
        if (resData.code > 0) {
          this.$message({ message: resData.message, type: "error" });
          return;
        }
        this.$message({ message: "保存成功", type: "success" });
        this.isEditing = false;
        await this.loadList();
      } catch (e) {}
    },
  },
};
</script>
